<template>
  <div class="ChaptersMenu" :class="{ 'is-ready': ready }">

    <div
      class="ChaptersMenu__col"
      :style="{
        width: $route.params.chapter == chapter[lang].slug ? width.chapter + 'px' : width.colonne + 'px',
        backgroundImage: getGradient(chapter)
      }"
      v-for="chapter in chapters"
      :key="chapter.id">
      <slot v-if="$route.params.chapter == chapter[lang].slug" />
      <router-link class="ChaptersMenu__link" v-if="$route.params.chapter != chapter[lang].slug" :to="{ name: 'chapters.' + lang, params: { chapter: chapter[lang].slug } }">
        <div class="ChaptersMenu__titles">
          <div class="ChaptersMenu__titles-rotate">
            <div v-if="chapter.index !== 0" class="ChaptersMenu__title is-1">{{ trans('Global.chapter') }} {{ chapter.index }}</div>
            <div class="ChaptersMenu__title is-2">{{ chapter[lang].title }}</div>
          </div>
        </div>
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ChaptersMenu',
  data: () => ({
    ready: false,
    width: {
      chapter: 0,
      colonne: 0,
    }
  }),
  watch: {
    '$root.width': 'setWidth',
    '$root.height': 'setWidth',
  },
  mounted() {
    this.setWidth()
    TweenLite.delayedCall(.5, () => this.ready = true)
  },
  methods: {
    setWidth() {
      this.$nextTick(() => {
        this.width.chapter = this.$el.querySelector('.Chapter').offsetWidth
        this.width.colonne = (window.innerWidth - this.width.chapter) / 5
      })
    },
    getGradient(chapter) {
      return `linear-gradient(to bottom, ${chapter.colors.primary}, ${chapter.colors.secondary})`
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ChaptersMenu
  height 100%
  display flex
  &.is-ready
    .ChaptersMenu__col
      transition width 1s

  &__titles
    transform-origin center center
    white-space nowrap
    position absolute
    top 50%
    left 50%
    transform translate(-50%, 0%)
    width 200px
    line-height 20px
    text-align right
    font-size 19
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

  &__title
    &.is-1
      font-weight 100
    &.is-2
      font-weight 700
      margin-top 5px

  &__titles-rotate
    transform rotate(-90deg)

  &__link
    display block
    height 100%
    width 100%
    position absolute
    top 0
    left 0

  &__col
    height 100%
    width 100%
    position relative
    overflow hidden
    &:first-child
      .ChaptersMenu__titles-rotate
        top 8px
        position relative


</style>
